<template>
    <div class="ui-content dashboard">
        <div class="institute-drop">
            <div class="past-test-dropdown" v-if="students.length > 1 && isParent">
                <v-select
                    @change="updateSelectedStudent"
                    :items="students"
                    v-model="selectedStudent"
                    hide-details
                ></v-select>
            </div>
        </div>
        <div class="page-user user my-healt-hg">
            <v-row class="health-align">
                <v-col 
                v-for="(subject, idx) in subjects"
                :key="idx"
                :href="'#'+idx"
                col="auto" sm="3" class="border-right-health chapter-health-prog"> {{subject.title}}
                    <v-card>
                        <SubjectHealth
                            :selectedSubject="subject"
                            :studentId="studentId"
                        />
                        <div class="add-subject">
                        <v-btn
                            @click="openSubjectHealth(subject)"
                            class="chapterwise-health-btn"
                            fab
                            >
                            <v-icon class="v-iconmargintop" dark>mdi-plus</v-icon>
                        </v-btn>
                        Chapterwise Health
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import SubjectHealth from "@/components/student/health/SubjectHealth.vue";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
    name: "MyHealth",
    components: {
        SubjectHealth
    },
    mounted() {
        this.addBreadCrumbChilde([]);
        if (this.user.role_id == this.roleIds.PA) {
            this.initStudentData();
        } else {
            this.studentId = this.user.id;
            this.getStudentHealth();
        }
    },
    computed: {
        ...mapState("userStore", ["user"])
    },

    data() {
        return {
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tab: null,
            students: [],
            selectedStudent: [],
            studentId: null,
            isParent: false,
            subjects: [],
            subject_two:[],
            selectedSubject: {},
            subjectForChapterHealth: {},
            chartOptions: {
                chart: {
                    type: "pie"
                },
                labels: [],
                legend: {
                    show: false
                },
                fill: {},
                tooltip: {
                    enabled: false
                },
                dataLabels: {
                    enabled: false
                },
                states: {
                    hover: {
                        filter: {
                            type: "none"
                        }
                    }
                },
                tooltip: {
                    enabled: false
                }
            }
        };
    },
    methods: {
        ...mapActions({
            setSelectedSubjectData: "healthStore/setSelectedSubjectData",
            getMyHealthData: "healthStore/getMyHealthData",
            getStudentSubjectTree: "resultStore/getStudentSubjectTree",
            getChildren: "resultStore/getChildren",
        }),
        ...mapMutations("app", ["addBreadCrumbChilde", "onMenuSelected"]),
        updateSelectedStudent() {
            this.studentId = this.selectedStudent.id;
            let crd = this.getCurrentRouteDetails('my-health'); 
            crd.selectedStudent = this.selectedStudent;
            this.setRouteDetails(crd);
            this.getStudentHealth();
        },
        initStudentData() {
            this.isParent = true;
            this.students = this.user.students.map(student => {
                let studentObj = {
                    text: student.name,
                    value: {
                        id: student.id,
                        batchId: student.batch_id
                    }
                };
                return studentObj;
            });
            let crd = this.getCurrentRouteDetails('my-health');
            this.selectedStudent = crd && crd.selectedStudent ? crd.selectedStudent : this.students[0].value;
            this.studentId = this.selectedStudent.id;
            this.getStudentHealth();
        },
        getColor(percentage) {
            let color = "";
            if (percentage > 65) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
            } else if (percentage > 19) {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
            } else {
                color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
            }
            return color;
        },
        getStudentHealth(subject) {
            this.$root.showLoader = true;
            let me = this;
              let  reqData = {
                    "student_id": this.user.id,
                    // "subject_id":subject.id
                }
                if(this.isParent){
                    reqData.student_id = this.studentId;
                }
                this.getStudentSubjectTree(reqData)
                .then(response => {
                    if (response.length > 0) {
                        this.processHealthData(response);
                    }
                    this.$root.showLoader = false;
                })
                .catch(err => {
                    me.$root.showLoader = false;
                });


        },
        processHealthData(response) {
            let subjectObj = {}
            if(response.length > 0) {
                let currentSubject = response[0];
                subjectObj.name =currentSubject.title;
                subjectObj.id = currentSubject.id;
                subjectObj.health = currentSubject.health;
                subjectObj.chapters = [];
                this.subjects.name = currentSubject.title;
                this.subjects.id = currentSubject.id;
                if(currentSubject.chidren.length > 0) {
                    currentSubject.chidren.map(c =>{
                        let chapterObj = {}
                        chapterObj.name = c.title;
                        chapterObj.id = c.id;
                        chapterObj.health = c.health;
                        subjectObj.chapters.push(chapterObj)
                    })
                }
                
            }
             this.selectedSubject = subjectObj;
             this.subjects = response;
            this.setSelectedSubjectData(this.selectedSubject);
        },
        openSubjectHealth(subject) {
            this.$router.push({ name: "chapters-health", params: {subject_name: subject.title, subject_id: subject.id, student_id: this.studentId}});
        },
    },
};
</script>